import { IEnvironmentBase } from "src/models/models";

export const baseEnvironment: IEnvironmentBase = {
  production: false,
  // to read this successfully need to change tsconfig.app.json
  // to include "node" in compilerOptions types
  VERSION: require("../../package.json").version,
};
